exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saleBarcode{width:150px;height:20px}", ""]);

// exports
